// export const API_ROOT = 'https://api-edge-us-dev.inherinext.compassbioinfo.com/'
export const API_ROOT = 'https://server.us.edge.inherinext.com/'

// export const WS_ROOT = 'wss://api-edge-us-dev.inherinext.compassbioinfo.com/cable'
export const WS_ROOT = 'wss://server.us.edge.inherinext.com/cable'



// WEBPACK FOOTER //
// ./src/api/config.js